import { useEffect, useState } from "react";
// Example: const [isOpen, setOpen] = useLocalStorage('is-open', false);
// if localstorage does not contain "is-open" it will fall back to the state false
export const useLocalStorage = <T>(storageKey: string, fallbackState: any) => {
  const item = localStorage.getItem(storageKey);
  const [value, setValue] = useState<T>(typeof item === "string" ? JSON.parse(item) : fallbackState);
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value, storageKey]);

  return { value, setValue };
};
